import { staticComponentValueConverter } from '../StaticComponentValues';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useMemo } from 'react';

const staticData = {
  height: 30,
};
function SearchBase({ item, imageWidth, aspectRatio, activeBigger, isCentered }) {
  const images = item?.data?.images || [];
  const min = item?.variantData?.minImage;
  const customization = staticComponentValueConverter(item?.customization);
  const iconFilter = useMemo(() => HexToHueConverter(customization?.searchIconColor), [customization?.searchIconColor]);
  const convertedStaticData = staticComponentValueConverter(staticData);
  return (
    <div
      style={{
        padding: `${customization?.containerPadding}`,
        backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
        backgroundImage:
          customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }}
    >
      <div
        className=" relative min-w-full border-1 flex flex-row items-center gap-[5%] bg-white"
        style={{
          padding: `${customization?.padding}`,
          borderColor: `${customization?.borderColor}`,
          borderRadius: `${customization?.borderRadius}`,
          backgroundColor: customization?.innerBackgroundColor,
        }}
      >
        {customization?.isSearchIcon && (
          <div className="  shrink-0  h-full flex justify-center items-center my-auto  py-[0.5%] px-[0.25%]">
            <div
              className=" 2xl:rounded-[10px] rounded-[7.97341324459px] p-[4px] 2xl:p-[5.016px] "
              style={{
                backgroundColor: customization?.searchIconBackgroundColor,
                color: customization?.searchIconColor,
                borderRadius: customization?.searchIconBorderRadius,
              }}
            >
              <img
                src={customization?.searchIcon}
                style={{ width: customization?.searchIconWidth, filter: iconFilter }}
                alt=""
              />
            </div>
          </div>
        )}
        <div
          style={{
            color: customization?.textColor,
            fontSize: customization?.textSize,
            minHeight: convertedStaticData.height,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: customization?.isSearchIcon ? 0 : 10,
          }}
        >
          {customization?.placeholder || 'Ara'}
        </div>
      </div>
    </div>
  );
}

export default SearchBase;
